<template>
  <collapse-box id="visa-reminder" v-if="product.reminder" :minHeight="72">
    <product-card-box title="温馨提示">
      <collapse-content>
        <div class="content-box">
          <div class="content-item" v-for="(item, index) in product.reminder.split('\n')" :key="index">{{
            item
            }}</div>
        </div>
      </collapse-content>
      <collapse-btn-cover-content></collapse-btn-cover-content>
    </product-card-box>
  </collapse-box>
</template>

<script>
import CollapseBox from '../../../../components/common/collapse/collapse-box';
import CollapseContent from '../../../../components/common/collapse/collapse-content';
import ProductCardBox from './product-card-box.vue';
import CollapseBtnCoverContent from '../../../../components/common/collapse/collapse-btn-cover-content.vue';

export default {
  components: {
    CollapseBox,
    CollapseContent,
    ProductCardBox,
    CollapseBtnCoverContent,
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {
  },
  created() {},
  methods: {},
};
</script>

<style lang="less" scoped>
.content-box{
  .content-item{
    font-size: 14px;
    color: #5F666E;
    line-height: 24px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/product/product-info/components/visa-reminder.vue